import { useRoute, useRouter } from 'vue-router';
import { computed } from 'vue';
import { RouterHelper } from '@getaccept/lib-shared/src/helpers/router.helper';
import type { EidType } from '../../types/enums/eid-type';
import type { CriiptoStatus } from '../../types/enums/criipto-status';

export const REDIRECT_HASH_PREFIX = 'redir';
const EID_TYPE_QUERY_KEY = 'eidType';
const EID_STATUS_QUERY_KEY = 'eidStatus';
const ORDER_REF_QUERY_KEY = 'orderRef';
const AUTO_START_TOKEN_QUERY_KEY = 'autoStartToken';

export const useResumeEidSigning = () => {
  const route = useRoute();
  const router = useRouter();

  const hasIosHash = computed(() => route.hash && route.hash.includes(REDIRECT_HASH_PREFIX));

  const eidType = computed(
    () => RouterHelper.getQueryParameter(route.query[EID_TYPE_QUERY_KEY]) as EidType
  );
  const criiptoMethodSigningStatus = computed(
    () => RouterHelper.getQueryParameter(route.query[EID_STATUS_QUERY_KEY]) as CriiptoStatus
  );
  const bankIdSwedenOrderRef = computed(() =>
    RouterHelper.getQueryParameter(route.query[ORDER_REF_QUERY_KEY])
  );
  const bankIdSwedenAutoStartToken = computed(() =>
    RouterHelper.getQueryParameter(route.query[AUTO_START_TOKEN_QUERY_KEY])
  );

  const resetQueryParams = () => {
    const query = { ...route.query };

    delete query[EID_TYPE_QUERY_KEY];
    delete query[EID_STATUS_QUERY_KEY];
    delete query[ORDER_REF_QUERY_KEY];
    delete query[AUTO_START_TOKEN_QUERY_KEY];

    router.replace({ query, hash: hasIosHash.value ? '' : route.hash });
  };

  return {
    eidType,
    criiptoMethodSigningStatus,
    bankIdSwedenOrderRef,
    bankIdSwedenAutoStartToken,
    resetQueryParams,
  };
};
